<template>
    <b-row>
        <b-col md="12">
            <gofix-card class="mb-0" fullContent>
                <gofix-default-table :settings="tableConfig" :table-items="tableItems" @load-items="getTableData" ref="gofixTable">
                    <template slot="gofix_table:reported_time" slot-scope="row">
                        {{row.item.reported_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","HH:mm")}}
                    </template>
                    <template slot="gofix_table:reported_date" slot-scope="row">
                        {{row.item.reported_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
                    </template>
                </gofix-default-table>
            </gofix-card>
            </div>
        </b-col>
    </b-row>
</template>
<script>
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'
export default {
    name: 'case_repeated_feedback',
    data() {
        let filter = JSON.parse(JSON.stringify(filters['case_management_repeated_feedback']));
        return {
            tableConfig: {
                name: 'case-management-repeated-feedback',
                controls: {
                    tableImport: false,
                    create: false,
                    delete: false,
                    tableExport: false
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: 1,
                sortColumn: "id",
                sortDirection: "asc"
            },
            tableItems: [],
        }
    },
    computed: {
        ...mapGetters({
            CaseItem: "CaseManagementController/Item"
        })
    },
    created() {},
    methods: {
        /*---------- Table event ----------*/
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            tableRequest.useDatabaseView = 1;
            tableRequest.filter.case_number.value = this.CaseItem.case_number;
            tableRequest.filter.client_contract_id.value = this.CaseItem.client_contract_id;
            tableRequest.filter.status.value = "Repeated Feedback";
            await this.$store.dispatch("CaseManagementController/getList", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;
                    this.$emit("update-total", response.data.data.total);
                    resolve(response.data.data);
                })
                .catch(err => {
                    this.$alertNotification("Can not load the case repeated feedback", "danger");
                    reject();
                })
        }
        /*----------------------------------------*/
    }
}
</script>